/*
 * CookieRead.js
 * Created by Zain Syed | Chester Rivas
 * Utility to create mappings of cookies onto the global window object;
 * required by components in & out of the angular SPA space
 * also setting and reading legacy cookies
 */

(function () {

  'use strict';

  // The 3 main objects (userPref, atg, userInfo) required by
  // components in/out of the SPA; should contain the default values.

  /**
   * @description stores user preferences like province/language
   * @type {{province: string, getUserPref: boolean, firstTimeUser: boolean, language: string, samKey: string, cartQuantity: number}}
   * @private
   */
  window.__userPref = {
    province: 'on',
    getUserPref: true,
    firstTimeUser: true,
    language: 'en',
    samKey: 'default',
    cartQuantity: 0
  };

  /**
   * @description stores userId and hashKey, required by commerce backends
   * @type {{userId: {value: string}, hashKey: {value: string}}}
   * @private
   */
  window.__atg = {
    userId: {
      value: 'default'
    },
    hashKey: {
      value: 'default'
    }
  };

  /**
   * @description certain page views are tracked after the user is logged in (passive tracking). This object
   * tracks those views.
   * @type {{}}
   * @private
     */
  window.__passiveTracking = {};

  /**
   * @description stores authenticated user's information
   * @type {{}}
   * @private
   */
  window.__userInfo = {};

  /**
   * @description helper method to get url params even they are url encoded
   * @param name
   * @returns {string}
   */
  window.getParameterByName = function (name) {

    var decodedURL,
      decodedName,
      regex,
      results;

    decodedURL = decodeURIComponent(location.href);

    decodedName = decodedURL
      .replace(/[\[]/, '\\[')
      .replace(/[\]]/, '\\]');

    regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    results = regex.exec(decodedName);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));

  };

  /**
   * @description deletes cookie
   * @param name
   * @param isJson
   */
  window.deleteCookie = function (name, isJson) {
    $.cookie.json = isJson;
    $.removeCookie(name, {path: '/'});
    return $.cookie(name);
  };

  /**
   * @description reads cookie
   * @param name
   * @param isJson
   */
  window.getCookie = function (name, isJson) {
    $.cookie.json = isJson;
    return $.cookie(name);
  };

  /**
   * @description sets cookie
   * @param name
   * @param value
   * @param options
   * @param isJson
   */
  window.setCookie = function (name, value, options, isJson) {

    /* This fix overrides ute-ui function window.setCookie and eliminates duplicated cookies in different domains, e.g. "www.fido.ca" and ".fido.ca".
     * It explicitly removes ".fido.ca" cookie with the same name before setting a new value within the window.setCookie function.
     * A similar fix is already available in ute-ui versions 0.10.x and up, so this patch won't be needed and can be removed once eclipse-web can be pointed to
     * ute-ui 0.10 or higher. */

     $.cookie.json = isJson;

     var domain = window.location.hostname.replace('www', ''); // remove sub-domain. e.g. "www.fido.ca" becomes ".fido.ca";
     $.removeCookie(name, { domain: domain, path: "/" });

    return $.cookie(name, value, options);
  };

  /**
   * @description sets cookie in the json of userPref
   * @param options -- array of key / value hash
   */
  window.setUserPrefCookies = function (options) {
    var userPref = {},
      reload = false;

    angular.copy(window.__userPref, userPref);

    _.each(options, function (option) {

      if (option.key === 'province' || option.key === 'language') {

        reload = true;
        window.setCookie(option.key, option.value, {
          expires: 30,
          path: '/'
        }, false);

      }

      userPref[option.key] = option.value;

      if (option.key === 'firstTimeUser') {
        window.__userPref.firstTimeUser = option.value;
      }

    });

    $.cookie.json = true;
    $.cookie('userPref', userPref, {
      expires: 30,
      path: '/'
    });

    if (reload) {

      window.location.reload();

    }

  };

  /**
   * @description gets cookie in the json of userPref
   * @param name
   */
  window.getUserPrefCookie = function (name) {

    var userPref = getCookie('userPref', true);

    if (!userPref) {
      userPref = window.__userPref;
    }

    return userPref[name];

  };

  ///////////////////////////////////////////////////

  if (getCookie('userPref', true)) {

    // 1 - extend from userPref cookie
    window.__userPref = _.extend(window.__userPref, getCookie('userPref', true));

  }

  ///////////////////////////////////////////////////

  var livesiteLang = getParameterByName('setLanguage').toLowerCase();
  var cfaLang = getParameterByName('language').toLowerCase(); // language param from CFA url
  var lithiumLang = getParameterByName('lang').toLowerCase();
  var allLanguages = ['en', 'fr'];

  var livesiteProvince = getParameterByName('setProvince').toLowerCase();
  var cfaProvince = getParameterByName('province').toLowerCase(); // province param from CFA url
  var allProvinces = ['ab', 'bc', 'mb', 'nb', 'nl', 'ns', 'on', 'pe', 'qc', 'sk'];

  if (_.contains(allLanguages, lithiumLang) || _.contains(allLanguages, livesiteLang) || _.contains(allLanguages, cfaLang) || _.contains(allProvinces, livesiteProvince) || _.contains(allProvinces, cfaProvince)) {

    // 2 - set from url param
    console.log('> param vars exists');

    if (_.contains(allLanguages, livesiteLang)) {

      console.log('livesite language:', livesiteLang);

      window.__userPref.language = livesiteLang;

    } else if (_.contains(allLanguages, lithiumLang)) {

      console.log('lithium language:', lithiumLang);

      window.__userPref.language = lithiumLang;

    } else if (_.contains(allLanguages, cfaLang)) {

      console.log('CFA language:', cfaLang);

      window.__userPref.language = cfaLang;

    }

    if (_.contains(allProvinces, livesiteProvince)) {

      console.log('livesite province:', livesiteProvince);

      window.__userPref.province = livesiteProvince;
      window.__userPref.getUserPref = false;

      window.setCookie('province', livesiteProvince, {
        expires: 30,
        path: '/'
      }, false);

    } else if (_.contains(allProvinces, cfaProvince)) {

      console.log('CFA province:', cfaProvince);

      window.__userPref.province = cfaProvince;
      window.__userPref.getUserPref = false;

      //window.setCookie('province', cfaProvince, {
      //  expires: 30,
      //  path: '/'
      //}, false);

    }

  } else if (getCookie('language', false) || getCookie('province', false) || getCookie('itemsInCart', false)) {

    // 3 - set from legacy cookie if url param DOES NOT exist
    console.log('> legacy cookie exists');

    if (getCookie('language', false)) {
      window.__userPref.language = getCookie('language', false);
    }

    if (getCookie('province', false)) {
      window.__userPref.province = getCookie('province', false).toLowerCase();
    }

    // CQUSR01153081 - don't overwrite window.__userPref.cartQuantity by itemsInCart, commented out following lines
    /*
    if (getCookie('itemsInCart', false)) {
      window.__userPref.cartQuantity = getCookie('itemsInCart', false);
    }*/

  }

  console.log('setting userPref cookie:', window.__userPref);

  // set ute cookies
  setCookie('userPref', window.__userPref, {
    expires: 30,
    path: '/'
  }, true);

  // From Kevin Chan:
  // Province is upper case. Language is lower case.

  // set legacy cookies
  setCookie('language', window.__userPref.language.toLowerCase(), {
    expires: 30,
    path: '/'
  }, false);

  //setCookie('province', window.__userPref.province.toUpperCase(), {
  //  expires: 30,
  //  path: '/'
  //}, false);

  //setCookie('itemsInCart', window.__userPref.cartQuantity, {
  //  expires: 30,
  //  path: '/'
  //}, false);

  ///////////////////////////////////////

  // check if there is a atg cookie
  if (getCookie('atg', true)) {

    window.__atg = _.extend(window.__atg, getCookie('atg', true));

  } else {

    setCookie('atg', window.__atg, {
      expires: 30,
      path: '/'
    }, true);

  }

  // check if there is a userInfo cookie
  if (getCookie('userInfo', true)) {

    window.__userInfo = _.extend(getCookie('userInfo', true), window.__userInfo);

  } else {

    setCookie('userInfo', window.__userInfo, {
      expires: 30,
      path: '/'
    }, true);

  }


})();
